<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="change_inform">
      <div class="title">项目信息</div>
      <el-form :inline="true" :model="form" class="form_table" ref="form" :inline-message="true">
        <el-form-item label="采购编号" prop="schemeCode">{{ form.schemeCode }}</el-form-item>
        <el-form-item label="项目名称" prop="projectName">{{ form.projectName }}</el-form-item>
        <el-form-item label="澄清问题内容" prop="content">{{ form.content }}</el-form-item>
        <el-form-item label="澄清问题文件" prop="content">
          <div v-for="(item, index) in files" :key="index">
            <el-link :underline="false" type="primary" @click="downLoadFile(item.fileId, item.fileName)"> {{ item.fileName }}</el-link>
          </div>
        </el-form-item>
        <el-form-item label="澄清回执模板">
          <el-button type="primary" plain @click.stop="downLoadTemplate()" style="margin-left: 5px; height: 32px">下载模版 </el-button>
          <span style="color: orange; margin-left: 10px">
            <img src="@/assets/img/icon_tips0.png" />
            请下载澄清回执模板，按模板格式填写回复内容并转换成pdf文件后提交
          </span>
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>
      <div>
        <div id="title" style="height: 20px; width: auto; border-bottom: 1px solid #95c7f0; font-size: 17px; margin: 0 0 10px 0">
          <span>
            <strong
              >澄清问题文件
              <span style="color: orange; margin-left: 10px">
                <img src="@/assets/img/icon_tips0.png" />
                如确认以下文件内容无误，请插入CA盖章后提交
              </span>
            </strong>
          </span>
        </div>
        <div class="content_wrap">
          <div id="FileList" ref="FileList">
            <table>
              <thead>
                <tr>
                  <th width="30%">序号</th>
                  <th width="36%">投标文件</th>
                  <th width="35%">状态</th>
                </tr>
              </thead>
              <tbody>
                <tr class="quote" @click="ChangeShow(false)" :class="{ tender: !showQuoto }">
                  <td>1</td>
                  <td>
                    <span class="switch">澄清回复附件</span>
                  </td>
                  <td>
                    <span v-show="BidFile == undefined || BidFile == ''">
                      <el-link :underline="false" style="color: #054c81">---</el-link>
                    </span>
                    <span v-show="BidFile != undefined && BidFile != ''" class="el-icon-circle-check" style="color: green; font-size: 20px; font-weight: bold"></span>
                  </td>
                </tr>
                <tr class="quote" v-if="ischangePrice == true" @click="ChangeShow(true)" :class="{ tender: showQuoto }">
                  <td>2</td>
                  <td>
                    <span class="switch">算术性修改报价一览表</span>
                  </td>
                  <td>
                    <span v-show="QuotoFile == undefined || QuotoFile == ''">
                      <el-link :underline="false" style="color: #054c81">---</el-link>
                    </span>
                    <span v-show="QuotoFile != undefined && QuotoFile != ''" class="el-icon-circle-check" style="color: green; font-size: 20px; font-weight: bold"> </span>
                  </td>
                </tr>
                <tr class="quote" v-if="ischangePrice == false">
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="quote">
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="quote">
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div id="BJCAPdfDiv"></div>
          <div class="btn_wrap">
            <span class="btn btn_reg" @click.stop="fnSubmit">确认提交</span>
          </div>
        </div>
      </div>
      <!-- <el-row>
        <el-col :span="4" :offset="8">
          <div class="btn_wrap"><span class="btn_1 btn_reg" @click.stop="handleClose">取消</span></div>
        </el-col>
        <el-col :span="4"><span class="btn_1" style="width: 100%;" @click.stop="fnSubmit">文件盖章</span></el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      replyId: this.$route.query.replyId,
      clarifyId: this.$route.query.clarifyId,
      rowIndex: this.$route.query.rowIndex,
      title: '评标澄清回复',
      uploadUrl: '',
      limit: 1,
      businessType: '',
      schemeId: '',
      files: [],
      replyFiles: [],
      uploadCount: 0,
      successCount: 0,
      uploadData: {},
      form: {
        schemeCode: '',
        projectName: '',
        content: ''
      },
      ischangePrice: false,
      filePath: '',
      BidFile: '',
      QuotoFile: '',
      showQuoto: false,
      fileUrl: 'C://1M.pdf',
      savePath: 'http://localhost:28920/SupplierLogin/UploadFile2', //"C:\\gyc.pdf",
      saveType: 'net',
      token: '123456'
    }
  },
  mounted() {
    this.uploadData.loginToken = window.localStorage.getItem('loginToken')
    this.init()
    window.addEventListener('storage', (e) => {
      if (e.key == 'Reply') {
        this.$emit('updatereply', this.rowIndex)
        this.handleClose()
      }
    })
  },
  methods: {
    ChangeShow(obj) {
      this.showQuoto = obj
      this.viewPdf()
    },
    viewPdf() {
      var path = ''
      console.log(this.showQuoto)
      if (this.showQuoto) path = window.location.origin + this.filePath
      else path = this.fileUrl
      console.log(path)
      let height = document.documentElement.clientHeight - 500
      window.console.log(height)
      if (this.showQuoto) {
        document.getElementById('BJCAPdfDiv').innerHTML =
          '<iframe src="http://127.0.0.1:21051/PDFClient/viewer.html?fileUrl=' +
          path +
          '&savePath=' +
          this.savePath +
          '&saveType=' +
          this.saveType +
          '&token=' +
          this.token +
          '" id="BJCAPdfJsViewer" frameborder="0" scrolling="auto" width="80%" height="200"></iframe>'
      } else {
        document.getElementById('BJCAPdfDiv').innerHTML =
          '<iframe src="http://127.0.0.1:21051/PDFClient/viewer.html?' +
          'savePath=' +
          this.savePath +
          '&saveType=' +
          this.saveType +
          '&token=' +
          this.token +
          '" id="BJCAPdfJsViewer" frameborder="0" scrolling="auto" width="80%" height="200"></iframe>'
      }

      var frm = document.getElementById('#BJCAPdfJsViewer')

      this.changeFrameHeight()
    },
    changeFrameHeight() {
      var ifm = document.getElementById('BJCAPdfJsViewer')
      var FileListt = document.documentElement.clientHeight - 350
      ifm.height = document.documentElement.clientHeight - 350
      this.$refs.FileList.style.height = FileListt + 'px'
      // var ifm = document.getElementById("BJCAPdfJsViewer2");
      // ifm.height = document.documentElement.clientHeight - 6;
    },
    init() {
      let config = {
        params: {
          clarifyId: this.clarifyId
        }
      }
      this.getRequest('/EvaluationClarify/Clarify', config).then((res) => {
        if (res.data.errcode == 0) {
          this.uploadUrl = res.data.uploadUrl
          this.businessType = res.data.businessType
          this.schemeId = res.data.schemeId
          this.form.schemeCode = res.data.schemeCode
          this.form.projectName = res.data.projectName
          this.form.content = res.data.content
          this.files = res.data.files
          this.ischangePrice = res.data.ischangePrice
          this.filePath = res.data.filePath
          this.fnAddCAListener()
          this.viewPdf()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    handleClose() {
      this.$refs['uploader'].clearFiles()
    },
    downLoadTemplate() {
      let token = window.localStorage.getItem('loginToken')
      var url = '/EvaluationClarify/DownLoadTemplate?schemeId=' + this.schemeId + '&loginToken=' + encodeURIComponent(token)
      this.downloadfile(this.baseURL + url)
    },
    downLoadFile(fileId, fileName) {
      let token = window.localStorage.getItem('loginToken')
      token = token.replace('+', '%2B')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName=' + fileName
      this.downloadfile(this.baseURL + url)
    },
    fnSubmit() {
      var isSubmit = true
      if (this.BidFile == '') {
        this.$message.error('请先完成澄清回复附件签章后再提交！')
        isSubmit = false
        return
      }
      if (this.QuotoFile == '' && this.ischangePrice == true) {
        this.$message.error('请先完成算术性修改报价一览表后再提交！')
        isSubmit = false
        return
      }
      if (isSubmit) {
        let data = {
          replyId: this.replyId,
          BidFile: this.BidFile,
          QuotoFile: this.QuotoFile
        }
        this.postRequest('/EvaluationClarify/Reply', {
          clarifyId: this.clarifyId,
          jsonStr: JSON.stringify(data)
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('操作成功')
            localStorage.setItem('Reply', Math.random())
            setTimeout(() => {
              window.close()
            }, 1000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    fnSubmitForm() {
      this.GoCASeal()
      // this.postRequest('/EvaluationClarify/Reply', {clarifyId:this.clarifyId, jsonStr: JSON.stringify(data) }).then(res => {
      // 	if (res.data.errcode == 0) {
      // 		this.$message.success('操作成功');
      // 		this.$emit('updatereply',this.rowIndex);
      // 		this.handleClose();
      // 	} else {
      // 		this.$message.error(res.data.errmsg);
      // 	}
      // });
    },
    GoCASeal() {
      let routerData = this.$router.resolve({
        name: 'EvaluationClarifyCASeal',
        query: {
          clarifyId: this.clarifyId,
          replyId: this.replyId,
          fileId: this.replyFiles[0],
          projectName: this.form.projectName
        }
      })
      window.open(routerData.href, '_blank')
      setTimeout(() => {
        window.close()
      }, 1000)
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传${this.limit}个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      console.log(file)
    },
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      console.log(response)
      if (response.errcode == 0) {
        this.replyFiles.push(response.FileList[0].fileId)
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
        this.successCount++
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
      this.uploadCount++
      if (this.uploadCount >= fileList.length) {
        if (this.successCount < fileList.length) {
          this.$message.error('终止保存，部分文件上传失败')
          return
        }
        // this.fnSubmitForm();
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      console.log(err)
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:${err}`,
        position: 'bottom-right'
      })
    },
    handleBeforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (testmsg.toLowerCase() != 'doc' && testmsg.toLowerCase() != 'docx') {
        this.$message.error('请上传word文件!')
        return false
      }
    },
    fnSaveCAContent(e) {
      if (e.data.type == 'signPdfBase64') {
        console.log('开始保存CA的内容')
        if (e.origin != 'https://127.0.0.1:21061' && e.origin != 'http://127.0.0.1:21051') return
        var message = e.data.contents
        if (this.showQuoto) {
          this.QuotoFile = e.data.contents
          // this.QuoFinished = true;
        } else {
          // this.BidFinished = true;
          this.BidFile = e.data.contents
        }
      }
    },
    fnAddCAListener() {
      console.log('添加CA监听')
      window.addEventListener('message', this.fnSaveCAContent)
    },
    fnRemoveCAListener() {
      console.log('移除CA监听')
      window.addEventListener('message', this.fnSaveCAContent)
    }
  }
}
</script>
<style scoped lang="scss">
.btn_wrap {
  display: block;
  text-align: center;
  margin-top: 15px;

  .btn {
    margin: 10px;
    color: #6a96bc;
    border: 1px solid #6a96bc;
    border-radius: 20px;
    padding: 5px 30px;
    cursor: pointer;
    // margin:auto;
  }

  .btn_reg {
    background: #0774d7;
    color: white;
  }

  .btn_reg2 {
    background: #2db7f5;
    color: white;
  }
}

.currentMenu {
  padding: 9px;
  margin: 7px;
}

.Tip {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;

  #tip1 {
    font-size: 16px;
    font-style: initial;
    font-weight: bold;
    padding-bottom: 20px;
    color: #0774d7;
  }
}

#FileList table tbody tr {
  height: 25px;
}

.quote td {
  background-color: #f8fbfe;
  padding: 10px;
  cursor: pointer;
}

.tender td {
  background-color: #d8eafa;
  padding: 10px;
  cursor: pointer;
}

#FileList {
  float: left;
  width: 18%;
  margin-right: 10px;
  height: 500px;
  background-color: #f8fbfe;
}

#FileList table {
  width: 100%;
  text-align: center;
}

#FileList td {
  height: 20px;
}

#FileList table thead {
  margin: 10px;
  color: white;
  background-color: #4f99d7;
}

#FileList table thead th {
  padding: 14px;
}

.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      // .btn_1 {
      //   width: 100%;
      // }
      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .welcome {
      height: 40px;
      line-height: 40px;
    }
  }

  .block_wrap {
    display: flex;
  }

  .left_block {
    flex: 3;

    .flex_block {
      display: flex;

      .block {
        flex: 1;
        background: #fff;
        margin-right: 20px;
        text-align: center;
        align-items: center;
        padding: 13px 0;

        .text1 {
          font-size: 46px;
          color: #219cf8;
        }

        .text2 {
          margin-top: 4px;
          color: #054c81;
        }
      }

      .block:nth-last-of-type(1) {
        margin-right: 0;
      }
    }
  }

  .flex_bottom {
    padding: 10px 15px 3px;
    background: #fff;
    margin-top: 10px;

    .fb_title {
      margin-bottom: 0;
    }
  }

  .right_block {
    width: 220px;
    background: #fff;
    margin-left: 10px;
    padding: 18px 15px 0;

    .text {
      font-size: 16px;
      border-bottom: 1px solid #95c7f0;
      padding-bottom: 3px;
      font-weight: bold;
    }

    .row_imgs {
      display: flex;
      margin: 15px 0 25px;

      .img_block {
        flex: 1;
        text-align: center;
        cursor: pointer;

        img {
          margin-bottom: 20px;
        }
      }
    }

    .row_imgs:nth-last-of-type(1) {
      margin-top: 33px;
    }
  }
}

#Shedure {
  height: 42px;
  width: auto;
  text-align: center;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .step {
    position: relative;
    border-radius: 50%;
    background: #e4e4e4;
    text-align: center;
    color: #999;
    display: inline-block;
    width: 30px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;

    .name {
      position: absolute;
      bottom: -27px;
      left: -11px;
      color: #999;
      white-space: nowrap;
    }
  }

  .active {
    color: #fff;
    background: #054c81;

    .name {
      color: #666;
    }
  }

  .line {
    width: 300px;
    height: 8px;
    background: #e4e4e4;
  }
}

.switch {
  cursor: pointer;
}

.mb_nav_pos {
  padding: 5px 0 0;
}

.EnterpriseInform {
  .content_wrap {
    padding-bottom: 20px;
    // padding-bottom: 50px;
    // margin-bottom: 20px;
  }
}
</style>